export function compareText(a, b) {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
}
export function sortRows(rows, value, direction) {
    return [...rows].sort((a, b) => {
        const left = value(a);
        const right = value(b);
        if (left == null || left === "")
            return right == null || right === "" ? 0 : 1;
        if (right == null || right === "")
            return -1;
        const compared = typeof left === "number" && typeof right === "number"
            ? left - right
            : compareText(String(left), String(right));
        return direction === "asc" ? compared : -compared;
    });
}
